import { render, staticRenderFns } from "./AdminEditDataLink.vue?vue&type=template&id=c49fd6c6&scoped=true&"
import script from "./AdminEditDataLink.vue?vue&type=script&lang=js&"
export * from "./AdminEditDataLink.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditDataLink.vue?vue&type=style&index=0&id=c49fd6c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49fd6c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c49fd6c6')) {
      api.createRecord('c49fd6c6', component.options)
    } else {
      api.reload('c49fd6c6', component.options)
    }
    module.hot.accept("./AdminEditDataLink.vue?vue&type=template&id=c49fd6c6&scoped=true&", function () {
      api.rerender('c49fd6c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminEditDataLink.vue"
export default component.exports